import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "c-w-header" }
const _hoisted_2 = { class: "title__name" }
const _hoisted_3 = {
  key: 0,
  class: "title__sub"
}
const _hoisted_4 = { class: "actions" }

import {RefreshCcw04, SearchMd, Moon01} from "utruckin-icons";
import {useRoute} from "vue-router";
import {computed, onMounted, onUnmounted, ref} from "vue";
import WidgetProfile from "@/components/widget/WidgetProfile.vue";
import {useAppStore} from "@/store/app.store";
import {useTheme} from "@/utils/useMode";
import CommonModal from "@/components/common/CommonModal.vue";
import GlobalSearchInput from "@/components/widget/ui/globalSearchInput.vue";
import GlobalSearchTab from "@/components/widget/ui/globalSearchTab.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetHeader',
  setup(__props) {

const route = useRoute();
const appStore = useAppStore();
const {toggleTheme, watchSystemTheme} = useTheme();

let cleanup: (() => void) | null = null;

const searchModal = ref<boolean>(false);
const loading = ref<boolean>(true);

const routerName = computed(() => {
  const fullRoute = route.name as string;
  return fullRoute?.split("-")[0];
});

const refresh = () => {
  appStore.triggerRefresh();
};

const openSearchModal = () => {
  searchModal.value = true;
}

const closeModal = () => {

}

onMounted(() => {
  cleanup = watchSystemTheme();
});

onUnmounted(() => {
  cleanup?.();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["title", _unref(route).params.id ? 'link' : ''])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(routerName.value), 1),
        (_unref(route).params.id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/ " + _toDisplayString(_unref(route).params.id), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "search",
          onClick: openSearchModal
        }, [
          _createVNode(_unref(SearchMd), { search: 20 }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Search", -1))
        ]),
        _createElementVNode("div", {
          class: "refresh",
          onClick: refresh
        }, [
          _createVNode(_unref(RefreshCcw04), { size: 24 })
        ]),
        _createElementVNode("div", {
          class: "theme",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args)))
        }, [
          _createVNode(_unref(Moon01), { size: 24 })
        ]),
        _createVNode(WidgetProfile)
      ])
    ]),
    _createVNode(CommonModal, {
      modelValue: searchModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchModal).value = $event)),
      onClose: closeModal,
      "close-on-overlay": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(GlobalSearchInput),
          _createVNode(GlobalSearchTab)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})